import { render, staticRenderFns } from "./UserCommentControl.vue?vue&type=template&id=5a731147&scoped=true&"
import script from "./UserCommentControl.vue?vue&type=script&lang=js&"
export * from "./UserCommentControl.vue?vue&type=script&lang=js&"
import style0 from "./UserCommentControl.vue?vue&type=style&index=0&id=5a731147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a731147",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VFlex,VForm,VSheet,VTextField})
